export default __webpack_public_path__ + "static/media/IMG_4891.8f4d4388.jpg";